import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { UserService } from '../../../../core/services/user.service';
import { ASSIGNABLE_STAFF_ROLES } from '../../../../core/configs/permissions.config';
import { JobService } from '../../../../core/services/job.service';
import {defaultTime, getConvertedTimeOptions} from "../../../../core/utli-functions/time";
import * as moment from "moment/moment";

interface Options {
  name: string;
  value: string;
}
@Component({
  selector: 'app-edit-recurring-job-popup',
  templateUrl: './edit-recurring-job-popup.component.html',
  styleUrls: ['./edit-recurring-job-popup.component.scss'],
})
export class EditRecurringJobPopupComponent implements OnInit {
  @Input() visibleEditJobPopup: boolean | undefined;
  @Input() recurringJob!: any;
  @Input() startTime!: any;
  @Input() timezone!: any;
  @Output() editJobPopupOnChange: EventEmitter<any> = new EventEmitter();

    shiftStartTime = defaultTime('07:00 AM');
    shiftEndTime = defaultTime('03:00 PM');
  staff: any;
  staffOptions: Options[] = [];
  modifiedRecurringData: any;
  saveJobLoading = false;
  loading = false;
  isModifiedRecurringExist = false;
    timeOptions: any = getConvertedTimeOptions();

  constructor(
    private messageService: MessageService,
    private userService: UserService,
    private jobService: JobService
  ) {}
  ngOnInit() {
    this.getDataAndSet();
  }
  getDataAndSet() {
      this.loading = true;
      this.getRecurringModify();
  }
    getRecurringModify(): void {
        const payload = {
            _id: this.recurringJob._id,
            date: moment(this.recurringJob.startDateAndTime).format('YYYY-MM-DD'),
        };
      this.jobService.getOneRecurringModify({...payload}).subscribe({
          next: (res) => {
              if (res.length !== 0){
                  this.modifiedRecurringData = res[0] ;
                  this.isModifiedRecurringExist = true;
                  this.shiftStartTime = moment(
                          this.modifiedRecurringData?.shiftStartTime
                      ).format('HH:mm');
                  this.shiftEndTime = moment(this.modifiedRecurringData?.shiftEndTime).format('HH:mm');
                  this.getStaff()
              }else {
                  this.isModifiedRecurringExist = false;
                  this.getStaff()
              }

          },error:(error) =>{
              this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: `${
                      error?.error?.message ? error?.error?.message : 'Error'
                  }`,
              });
        }
      })
    }

    getStaff(): void {
        this.staff = [];
        this.staffOptions = [];
        this.userService
            .getFilteredUsers({
                active: true,
                company: this.recurringJob.company._id,
                archived: false,
                onboardingComplete: true,
            })
            .subscribe({
                next: value => {
                    const assignable = (value as any[]).filter(
                        (u: any) => u?.role?.name && ASSIGNABLE_STAFF_ROLES.includes(u.role.name)
                    );
                    assignable.forEach((st: any) => {
                        this.staffOptions.push({
                            name: `${st.firstname} ${st.lastname}`,
                            value: st._id,
                        });
                    });

                    if (this.isModifiedRecurringExist) {
                        this.modifiedRecurringData.staff.map((st: any) => {
                            this.staff.push({
                                name: `${st.firstname} ${st.lastname}`,
                                value: st._id,
                            });
                        });
                    }else{
                        this.recurringJob.staff.map((st: any) => {
                            this.staff.push({
                                name: `${st.firstname} ${st.lastname}`,
                                value: st._id,
                            });
                        });
                    }


                    this.loading = false;
                },
                error: error => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: `${
                            error?.error?.message ? error?.error?.message : 'Error'
                        }`,
                    });
                },
            });
    }

  saveData() {
    this.saveJobLoading = true;
    let staff: any[] = [];
    this.staff?.forEach((st: any) => {
      staff.push(st.value);
    });

      const modifiedStartTimeDate = moment()
          .set({
              hour: moment(this.shiftStartTime, 'hh:mm').hours(),
              minute: moment(this.shiftStartTime, 'hh:mm').minutes(),
              second: moment(this.shiftStartTime, 'hh:mm').seconds(),
          })
          .toDate();
      const modifiedEndTimeDate = moment()
          .set({
              hour: moment(this.shiftEndTime, 'hh:mm').hours(),
              minute: moment(this.shiftEndTime, 'hh:mm ').minutes(),
              second: moment(this.shiftEndTime, 'hh:mm').seconds(),
          })
          .toDate();
    this.jobService
      .updateRecurringJob({
        _id: this.modifiedRecurringData._id,
          shiftStartTime: modifiedStartTimeDate,
          shiftEndTime: modifiedEndTimeDate,
        staff: staff?.length > 0 ? staff.sort() : [],
      })
      .subscribe(
        () => {
          this.saveJobLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Job has been updated!',
          });
          this.editJobPopupOnChange.emit('save');
        },
        (error: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${
              error?.error?.message ? error?.error?.message : 'Error'
            }`,
          });
        }
      );
  }

    createData() {
        this.saveJobLoading = true;
        let staff: any[] = [];
        this.staff?.forEach((st: any) => {
            staff.push(st.value);
        });

        const modifiedStartTimeDate = moment()
            .set({
                hour: moment(this.shiftStartTime, 'hh:mm').hours(),
                minute: moment(this.shiftStartTime, 'hh:mm').minutes(),
                second: moment(this.shiftStartTime, 'hh:mm').seconds(),
            })
            .toDate();
        const modifiedEndTimeDate = moment()
            .set({
                hour: moment(this.shiftEndTime, 'hh:mm').hours(),
                minute: moment(this.shiftEndTime, 'hh:mm ').minutes(),
                second: moment(this.shiftEndTime, 'hh:mm').seconds(),
            })
            .toDate();

       const modifiedDate = moment(this.recurringJob.startDateAndTime).format('YYYY-MM-DD');


        const payload = {
            mainJob: this.recurringJob._id,
            date: modifiedDate,
            shiftStartTime: modifiedStartTimeDate,
            shiftEndTime: modifiedEndTimeDate,
            staff: staff?.length > 0 ? staff.sort() : [],
        }

        this.jobService.createRecurringModify(payload).subscribe({
            next: value => {
                this.saveJobLoading = false;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Job has been updated!',
                });
                this.editJobPopupOnChange.emit('save');
            },
            error: error => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: `${
                        error?.error?.message ? error?.error?.message : 'Error'
                    }`,
                });
            }
        })
    }

  closeJobDialog() {
    this.editJobPopupOnChange.emit('');
  }

    onShiftStartTimeChange(value: string | unknown) {
        this.shiftStartTime = value as string;
    }

    onShiftEndTimeChange(value: string | unknown) {
        this.shiftEndTime = value as string;
    }
}
